<template>
  <section>
    <div class="grid-container">
      <div class="grid-item">
        <welcome :userData="userData" />
        <filtro :isLoading="isLoading" class="mt-3" @buscar="buscar($event)" />
        <insBaseValue class="mt-3" :ins-base-value="dataDashboard.ins_base_value" />
        <statisticsPatients
          class="mt-3"
          :userData="userData"
          :dataDashboard="dataDashboard" />
        <averages
          class="mt-3"
          :averages="averages"
          :dates="fechas"
          :byType="byType"
        />
      </div>
      <div class="grid-item">
        <statistics :stadistics="stadistics" />
        <totalPatiens
          class="mt-3"
          :userData="userData"
          :dataDashboard="dataDashboard"
          :fechas="fechas" />
        <!-- <membership class="mt-3" :userData="userData" :memberships="sumMembership" /> -->
      </div>
    </div>
  </section>
</template>

<script>
import Welcome from '../components/welcome.vue'
import filtro from '../components/filter'
import statisticsPatients from '../components/statisticsPatients'
import totalPatiens from '../components/totalPatiens'
import statistics from '../components/statistics'
import averages from '../components/averages'
import insBaseValue from '@/view/pages/dashboard-all/components/insBaseValue.vue'
// import membership from '../components/membership'

export default {
  components: {
    averages,
    Welcome,
    filtro,
    statisticsPatients,
    totalPatiens,
    statistics,
    insBaseValue,
    // membership,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
      required: false,
    },
    dataDashboard: {
      type: Object,
      default: () => {},
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: () => false,
      required: false,
    },
  },
  data() {
    return {
      averages: [],
      stadistics: [],
      fechas: {
        start: '',
        end: '',
      },
      // sumMembership: { NP: 0, NC: 0 },
    }
  },
  watch: {
    dataDashboard() {
      this.stadistics = [
        {
          description:
            'Average diario del periodo de la fecha selecionada divido en los dias de ese periodo',
          value: parseInt(this.dataDashboard.average.income_days),
          title: 'Daily Average Income',
        },
        {
          description: 'Suma total del periodo de la fecha selecionada',
          value: parseInt(this.dataDashboard.totals.income),
          title: 'Total Income',
        },
      ]
      const avg = this.dataDashboard.average || {}
      this.averages = [
        {
          label: 'AVG_TOTAL',
          title: `Average total $${avg.total}`,
          averages: avg.total_daily,
        },
        {
          label: 'AVG_NC',
          title: `Average NC $${avg.nc}`,
          averages: avg.nc_daily,
        },
        {
          label: 'AVG_NP',
          title: `Average NP $${avg.np}`,
          averages: avg.np_daily,
        },
      ]
      // this.sumMembership = this.dataDashboard.memberships
    },
  },
  computed: {
    byType() {
      return Array.isArray(this.dataDashboard?.average?.by_type)
        ? this.dataDashboard.average.by_type
        : []
    },
  },
  methods: {
    buscar(filtro) {
      this.fechas = {
        start: filtro.start,
        end: filtro.end,
      }
      this.$emit('buscar', filtro)
    },
  },
}
</script>

<style scoped lang="scss">
@import '../assets/cssDashboards.css';
</style>
